module.exports = __webpack_public_path__ + "img/jiashan.a3a29e7d.png";